<template>
  <el-container style="margin: 0px;">
    <div class="aside">
      <div class="aside-header">
        <div style="padding-top: 7px;">
          <img src="/static/images/logo.png" style="width: 45px; height: 30px; position: relative; top: 8px; margin-left: 12px;">
          <b style="color: white; font-size: 18px; line-height: 47px;" v-show="logoTextShow">大模型服务平台</b>
        </div>
      </div>

      <el-aside :width="sideWidth+'px'">
        <el-menu :collapse-transition="false"
                 :collapse="isCollapse"
                 :default-openeds="['1', '2', '3']"
                 style="height: 100%;" >

          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span slot="title">账号中心</span>
            </template>
            <el-menu-item index="1-1" @click="gotoCustomerInfo" style="padding-left: 48px;"><i class="el-icon-s-home"></i>企业概览</el-menu-item>
            <el-menu-item index="1-2" @click="gotoAccountSecurity" style="padding-left: 48px;"><i class="el-icon-s-custom"></i>账号安全</el-menu-item>
            <el-menu-item index="1-3" @click="gotoApiKey" style="padding-left: 48px;"><i class="el-icon-key"></i>API KEY</el-menu-item>
          </el-submenu>

<!--          <el-submenu index="2">-->
<!--            <template slot="title">-->
<!--              <i class="el-icon-s-grid"></i>-->
<!--              <span slot="title">设备管理</span>-->
<!--            </template>-->
<!--            <el-menu-item index="2-1" @click="gotoDevice" style="padding-left: 48px;"><i class="el-icon-s-tools"></i>设备列表</el-menu-item>-->
<!--          </el-submenu>-->

          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span slot="title">资源管理</span>
            </template>
            <el-menu-item index="3-1" @click="gotoProduct" style="padding-left: 48px;"><i class="el-icon-s-order"></i>产品管理</el-menu-item>
            <el-menu-item index="3-2" @click="gotoPurchasedResourcePackage" style="padding-left: 48px;"><i class="el-icon-suitcase"></i>套餐购买记录</el-menu-item>
<!--            <el-menu-item index="3-21" @click="gotoPurchasedResourcePackage2" style="padding-left: 48px;"><i class="el-icon-suitcase"></i>资源包管理</el-menu-item>-->
            <el-menu-item index="3-3" @click="gotoStatistics" style="padding-left: 48px;"><i class="el-icon-s-data"></i>用量统计</el-menu-item>
          </el-submenu>

        </el-menu>

        <div style="flex: 1; font-size: 20px; padding-left: 21px; ">
          <span :class="collapseBtnClass" style="cursor: pointer; color: #999; background-color: rgba(209, 209, 209, 0.3); padding: 2px;" @click="collapse"></span>
        </div>
        <br>
      </el-aside>
    </div>

    <el-container style="height: 100vh;">
      <el-header style="text-align: right; font-size: 14px;"><span>
        <i class="el-icon-s-custom" style="margin-right: 4px;"></i>{{phone2}}
      </span>
        <span id="exitLogin" @click="logout"><i class="fas fa-sign-out-alt" style="margin-left: 10px; margin-right: 4px;"></i>退出</span>
      </el-header>

      <router-view style="border-left: solid 1px #ccc; height: 94vh;"/>

    </el-container>

  </el-container>

</template>

<script>
// import {mapState} from 'vuex'
import { removeLoginPhone, removeToken, removeUUID } from '@/common/auth'
import store from '@/store'
import {
  reqLogout
} from '@/api'

export default {
  name: 'CustomerCenter',
  data() {
    return {
      phone: '',
      isCollapse: false,
      collapseBtnClass: "el-icon-s-fold",
      sideWidth: 210,
      logoTextShow: true,
    }
  },

  methods: {

    //点击收缩按钮触发
    collapse(){
      //collapse为false时展开，为true时折叠。
      this.isCollapse = !this.isCollapse
      //折叠时
      if(this.isCollapse){
        //折叠时宽度为65
        this.sideWidth = 65
        //变换图标样式
        this.collapseBtnClass = 'el-icon-s-unfold'
        //折叠时不展示名称“ML后台管理系统”
        this.logoTextShow = false

        const navCollapse = 1.13
        this.$store.dispatch('setNavCollapse', {navCollapse})
      }else{
        //展开时宽度为210
        this.sideWidth = 210
        //变换图标样式
        this.collapseBtnClass = 'el-icon-s-fold'
        //展开时展示名称“ML后台管理系统”
        this.logoTextShow = true

        const navCollapse = 1
        this.$store.dispatch('setNavCollapse', {navCollapse})
      }
    },

    logout () {
      this.$confirm('确定退出系统吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await reqLogout()

        removeLoginPhone()
        const phone = ''
        await this.$store.dispatch('setPhone', {phone})

        removeToken()
        const token = ''
        await this.$store.dispatch('setToken', {token})

        removeUUID()
        await this.$router.replace('/login')
      }).catch(() => {
      })
    },

    gotoIndex () {
      this.$router.replace('/').catch(err => {})
    },

    gotoCustomerInfo () {
      this.$router.replace('/customerCenter/customerInfo').catch(err => {})
    },

    gotoAccountSecurity () {
      this.$router.replace('/customerCenter/accountSecurity').catch(err => {})
    },

    gotoApiKey () {
      this.$router.replace('/customerCenter/apiKey').catch(err => {})
    },

    gotoDevice () {
      this.$router.replace('/customerCenter/device').catch(err => {})
    },

    gotoProduct () {
      this.$router.replace('/customerCenter/product').catch(err => {})
    },

    gotoPurchasedResourcePackage () {
      this.$router.replace('/customerCenter/purchasedResPkg').catch(err => {})
    },

    gotoPurchasedResourcePackage2 () {
      this.$router.replace('/customerCenter/purchasedResPkg2').catch(err => {})
    },

    gotoStatistics () {
      this.$router.replace('/customerCenter/statistics').catch(err => {})
    },


    gotoUpdatePassword () {
      this.$router.replace('/customerCenter/updatePassword').catch(err => {})
    },

    gotoOrderList () {
      this.$router.replace('/customerCenter/orderList').catch(err => {})
    },

  },

  mounted () {
    this.phone = store.getters.phone
  },

  computed: {
    currentYear: function () {
      return new Date().getFullYear()
    },
    phone2 () {
      return this.phone.substr(0, 3) + '****' + this.phone.substr(7)
    },
  }
}
</script>

<style scoped>
  .aside {
    /*border: 1px solid orchid;*/
    /*background-color: rgba(6, 7, 8, 0.9);*/
    height: 100vh;
  }

  .aside-header {
    /*background-color: #c13532;*/
    background-color: rgba(3, 3, 3, 0.86);
    height: 60px;
  }

  .el-header {
    /*background-color: #c13532;*/
    background-color: rgba(3, 3, 3, 0.86);
    color: rgba(209, 209, 209, 0.8);
    line-height: 60px;
  }

  .el-footer {
    background-color: #fff;
    color: #666;
    line-height: 60px;
    font-size: 16px;
    text-align: center;
  }

  #exitLogin:hover {
    cursor:pointer;
  }

</style>



// WEBPACK FOOTER //
// src/pages/CustomerCenter/CustomerCenter.vue